import http from "../http";

export default {
  indexRounds(edition_modality_id){
    return http.plainAxiosInstance.get(`/championships/${edition_modality_id}/rounds`);
  },

  showRound(edition_modality_id, round_id) {
    return http.plainAxiosInstance.get(`/championships/${edition_modality_id}/rounds/${round_id}`);
  },

  indexRoundMatches(round_id){
    return http.plainAxiosInstance.get(`/rounds/${round_id}/matches`);
  }


}